import './reset.css'
import './style.css'

import Backbone from 'backbone'
import AppRouter from './router'
import Resize from './helpers/resize'
import { StatusBar } from '@capacitor/status-bar'
import { Capacitor } from '@capacitor/core'
import DetectOldBrowsers from './helpers/detect-old-browsers'
import Alert from './helpers/alert'
import messages from './messages'
import { initIAP } from './iap'
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { SplashScreen } from '@capacitor/splash-screen';

document.addEventListener('deviceready', async () => {
    // Hide the status bar if the plugin is available
    if (Capacitor.isPluginAvailable('StatusBar')) {
        await StatusBar.hide();
    }

    // Hide the splash screen
    if (Capacitor.isPluginAvailable('SplashScreen')) {
        await SplashScreen.hide();
    }

    // Initialize IAP after the native layer is ready
    if (Capacitor.getPlatform() !== 'web') {
        initIAP()
    }
});

// DOMContentLoaded for the rest of your app initialization.
document.addEventListener('DOMContentLoaded', async () => {
    // Detect outdated browsers
    const version = DetectOldBrowsers();
    if (version !== false) {
        Alert(messages.MSG_OLD_BROWSER);
        return;
    }

    // Call the Resize function and listen for window resize events
    Resize();
    window.addEventListener("resize", Resize);

    // Load the custom elements and wait for them to be defined
    try {
        await defineCustomElements(window);
    } catch (error) {
        console.error('Error loading Ionic PWA elements');
    }

    // Now that custom elements are loaded, initialize your app
    new AppRouter();
    document.title = 'Daydream Education - Revision Hub';
    Backbone.history.start();
});

